import { render, staticRenderFns } from "./ModalAddSpace.vue?vue&type=template&id=6d74c21e"
import script from "./ModalAddSpace.vue?vue&type=script&lang=js"
export * from "./ModalAddSpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports